import { gql } from '@apollo/client'

const ADD_ON_POLICY_FIELDS = gql`
  fragment AddOnPolicyFields on AddOnPolicy {
    basicDetails {
      name
      description
      descriptionTranslatedList {
        label
        value
        nativeLabel
      }
      id
    }
    cutoffHours
    table {
      applied
      priority
      penaltyAmount
      deadline
      deadlineTimeOffset
      penaltyType
      policyType
    }
  }
`

export const ADD_ON_POLICIES_QUERY = gql`
  ${ADD_ON_POLICY_FIELDS}
  query AddOnPolicies($providerCode: String!) {
    addOnPolicies(providerCode: $providerCode) {
      ...AddOnPolicyFields
    }
  }
`

export const ADD_ON_POLICY_QUERY = gql`
  ${ADD_ON_POLICY_FIELDS}
  query AddOnPolicy($providerCode: String!, $policyID: String!) {
    addOnPolicy(providerCode: $providerCode, policyID: $policyID) {
      ...AddOnPolicyFields
    }
  }
`

export const ADD_ON_POLICY_GENERATE = gql`
  mutation GenerateAddOnPolicy(
    $input: AddOnPolicyInput!
    $providerCode: String!
  ) {
    generateAddOnPolicy(input: $input, providerCode: $providerCode) {
      message
      id
    }
  }
`

export const ADD_ON_POLICY_MODIFY = gql`
  mutation ModifyAddOnPolicy(
    $input: AddOnPolicyInput!
    $providerCode: String!
  ) {
    modifyAddOnPolicy(input: $input, providerCode: $providerCode) {
      message
    }
  }
`

export const ADD_ON_POLICY_DELETE = gql`
  mutation DeleteAddOnPolicy($providerCode: String!, $policyID: String!) {
    deleteAddOnPolicy(providerCode: $providerCode, policyID: $policyID) {
      message
    }
  }
`
